// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"18890ba7","498":"701dfbb0","703":"8d6fe05d","787":"7d42724d"}[chunkId] + ".chunk.js";
};